
<template>
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit">{{$i18nUtil.trans("message.NewSite.001","신규 사이트 생성")}}</div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

    <div class="modal-content">
      <div class="input-box">
        <input
          type="text"
          :placeholder="$i18nUtil.trans('message.NewSite.004','사이트 관리자 ID')"
          @focus="$event.target.placeholder = ''"
          @focusout="$event.target.placeholder = $i18nUtil.trans('message.NewSite.004','사이트 관리자 ID')"
          v-model="userId"
        />
      </div>
    </div>
    <footer class="modal-footer">
      <button type="button" class="btn_ty1" @click="addManager">{{$i18nUtil.trans("button.save","저장")}}</button>
    </footer>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import EventBus from "@/js/eventbus/eventBus";
export default {
  data() {
    return {
      userId: "",
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
    };
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  mounted() {
    console.log(this.modalInfo);
  },
  methods: {
    ...mapActions("modals", ["showToast"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    addManager() {
      let obj = this;
      let reqData = {
        url: "/api/cogroup/cogroup/registGroup",
        method: "post",
        params: {
          groupKbn: this.modalInfo.groupKbn,
          userId: this.userId,
        },
      };
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          obj.hideLoadingbar();
          if (res.errorCode) {
            if (res.errorCode == "NOT_INTERNAL_USER") {
              obj.toastInfo.message = obj.$i18nUtil.trans("message.NewSite.002","관리자로 지정할 수 없는 ID입니다.");
              obj.showToast(obj.toastInfo);
            } else {
              console.log(res.errorCode);
            }
          } else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.NewSite.003","사이트가 생성되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.$emit("close");
          }
        })
        .catch((err) => {
          console.log(err);
          console.log("[사이트 생성 오류]");
        });
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/NewSite.vue